import "./index.scss";
import { insideBreakpoint, useBreakpoint } from "utilities/BreakpointProvider";
import React, { useEffect, useRef } from "react";

export type StickyDoubleColumnProps = {
  content: React.ReactNode;
  stickyContent: React.ReactNode;
};

const StickyDoubleColumn = ({
  content,
  stickyContent,
}: StickyDoubleColumnProps) => {
  const breakpoints = useBreakpoint();
  const refCard = useRef<HTMLDivElement>(null);
  const refCardContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const callbackScroll = () => {
      const { bottom: containerBottom } =
        refCardContainer.current!.getBoundingClientRect();
      const { bottom: cardBottom } = refCard.current!.getBoundingClientRect();
      const stickyElement = document.querySelector(".sticky-element");
      const { bottom: stickyBottom } = stickyElement!.getBoundingClientRect();
      const footer = document.querySelector(".footer-new__container");
      const { top: footerTop } = footer!.getBoundingClientRect();

      const areFooterAndStickyTouching =
        Math.floor(footerTop) <= Math.floor(stickyBottom);

      const isReachedBottom =
        insideBreakpoint(breakpoints, ["md"], false) === true
          ? Math.floor(cardBottom) <= 0
          : Math.floor(cardBottom) >= Math.floor(containerBottom);

      if (stickyElement) {
        if (!isReachedBottom || areFooterAndStickyTouching) {
          stickyElement.classList.remove("sticky-element--show");
        } else if (isReachedBottom) {
          stickyElement.classList.add("sticky-element--show");
        }
      }
    };

    window.addEventListener("scroll", callbackScroll);

    return () => {
      window.removeEventListener("scroll", callbackScroll);
    };
  }, [breakpoints]);

  return (
    <div className="sticky-double-column wrapContent wrapContentV2-xl-xl wrapContentV2-lg-xl wrapContentV2-md-lg wrapContentV2-sm-xl">
      <div className="sticky-double-column__left">{content}</div>
      <div ref={refCardContainer} className="sticky-double-column__right">
        <div ref={refCard} className="sticky-card">
          {stickyContent}
        </div>
      </div>
    </div>
  );
};

export default StickyDoubleColumn;
